import { createContext } from 'react';

import { PreciseCoordinates, Topic, Greeting, InitQuestion, Qna, TranslationObject, TopicResponse, TopicEntity } from '~/types';

import { MenuScreen, ProfileData, GeolocationConsent } from '~/App';

export interface AppContextType {
    apiUrl: string;
    profile: ProfileData | null;
    setProfile: (profile: ProfileData | null) => void;
    showResults: boolean;
    topicData: {
        topic: Topic;
        greeting: Greeting;
        initQuestion: InitQuestion;
        qna: Qna;
        translations: TranslationObject;
        entity: TopicEntity;
    } | null;
    setTopicData: (topicData: TopicResponse | null) => void;
    menuScreen: MenuScreen;
    setMenuScreen: (menuScreen: MenuScreen) => void;
    setGlassPanelColor: (color: string) => void;
    setGlassPanelBackdropFilter: (blur: number, saturate: number, brightness: number) => void;
    setLoading: (loading: boolean) => void;
    geolocationConsent: 'granted' | 'denied' | 'prompt' | null;
    setGeolocationConsent: (geolocationConsent: GeolocationConsent) => void;
    preciseCoordinates?: PreciseCoordinates;
    updatePreciseLocation: () => Promise<void>;
    revertSlider: () => void;
    setRevertSlider: (revertSlider: () => void) => void;
    triggerConfetti: () => void;
    recordAnalyticsEvent: (eventCategory: string, eventAction: string, topicId?: string, entityId?: number) => void;
    languageSelectorVariant: 'new' | 'old';
}

export const AppContext = createContext<AppContextType | null>(null);